var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 2.1679L22.8321 0L8.70234 14.1298L2.1679 7.6107L0 9.7786L8.70234 18.4809L25 2.1679Z",
    fill: "#06923E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2626 21.5251H1.73743V24.6002H23.2626V21.5251Z",
    fill: "#06923E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.0ac78f205eb40a48139f32f12d40871f.svg";
export { ForwardRef as ReactComponent };